import '@firebase/analytics-compat';
//# sourceMappingURL=index.esm.js.map
